import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { AvatarModule } from 'ngx-avatars';
import { ColorPickerModule } from 'ngx-color-picker';
import { HomeModule } from 'src/app/Modules/home/home.module';
import { SettingsModule } from 'src/app/Modules/settings/settings.module';
import { MaterialModule } from 'src/app/shared/material.module';
import { InsOrgHeadersModule } from '../instance-org-headers/ins-org-headers.module';
import { HierarchyFpsoOptionComponent } from './hierarchy-fpso-option/hierarchy-fpso-option.component';
import { HierarchyLngPlantComponent } from './hierarchy-lng-plant/hierarchy-lng-plant.component';
import { HierarchyPetrochemicalPlantComponent } from './hierarchy-petrochemical-plant/hierarchy-petrochemical-plant.component';
import { HierarchyRefineryOptionComponent } from './hierarchy-refinery-option/hierarchy-refinery-option.component';
import { HierarchyRigOptionComponent } from './hierarchy-rig-option/hierarchy-rig-option.component';
import { HierarchyOptionComponent } from './hierarchy-option/hierarchy-option.component';
import { HierarchyIdmsViewsComponent } from './hierarchy-idms-views/hierarchy-idms-views.component';
import { InstanceConfigurationDataComponent } from './informate-configuration/instance-configuration-data/instance-configuration-data.component';
import { InstanceConfigurationSidebarComponent } from './informate-configuration/instance-configuration-sidebar/instance-configuration-sidebar.component';
import { InstanceInformateConfigurationSettingsComponent } from './informate-configuration/instance-informate-configuration-settings/instance-informate-configuration-settings.component';
import { InstanceActivityPackStatusComponent } from './instance-activity-pack-status/instance-activity-pack-status.component';
import { InstanceActivityPacksComponent } from './instance-activity-packs/instance-activity-packs.component';
import { InstanceActivityWorkflowComponent } from './instance-activity-workflow/instance-activity-workflow.component';
import { InstanceInfoSectionComponent } from './instance-info-section/instance-info-section.component';
import { InstanceProjectTypeStatusComponent } from './instance-project-type-status/instance-project-type-status.component';
import { InstanceProjectTypeComponent } from './instance-project-type/instance-project-type.component';
import { InstanceUserReportsComponent } from './instance-user-reports/instance-user-reports.component';
import { InstanceUsersComponent } from './instance-users/instance-users.component';
import { InstanceViewsHierarchyComponent } from './instance-views-hierarchy/instance-views-hierarchy.component';
import { InstanceWizardAddComponent } from './instance-wizard-add/instance-wizard-add.component';
import { InstanceWizardDetailsComponent } from './instance-wizard-details/instance-wizard-details.component';
import { InstanceWorkpackReportsComponent } from './instance-workpack-reports/instance-workpack-reports.component';
import { InstanceComponent } from './instance/instance.component';
import { HierarchyViewEditComponent } from './hierarchy-view-edit/hierarchy-view-edit.component';
import { NgJsonEditorModule } from 'ang-jsoneditor';
import { InstanceOthersComponent } from './instance-others/instance-others-index/instance-others.component';
import { LineNumberFormatDetailsComponent } from './instance-others/line-number-format-details/line-number-format-details.component';
import { JoinIdFormatDetailsComponent } from './instance-others/join-id-format-details/join-id-format-details.component';
import { NestedRenderComponent } from './nested-render/nested-render.component';
import { ReportsModule } from 'src/app/Modules/idms/components/reports/reports.module';
import { InstanceConfSidebarDataComponent } from './instance-conf-sidebar-data/instance-conf-sidebar-data.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
    declarations: [
        HierarchyFpsoOptionComponent,
        HierarchyLngPlantComponent,
        HierarchyPetrochemicalPlantComponent,
        HierarchyRefineryOptionComponent,
        HierarchyRigOptionComponent,
        HierarchyOptionComponent,
        InstanceInformateConfigurationSettingsComponent,
        InstanceComponent,
        InstanceActivityPackStatusComponent,
        InstanceActivityPacksComponent,
        InstanceActivityWorkflowComponent,
        InstanceInfoSectionComponent,
        InstanceOthersComponent,
        InstanceProjectTypeComponent,
        InstanceProjectTypeStatusComponent,
        InstanceUsersComponent,
        InstanceUserReportsComponent,
        InstanceUsersComponent,
        InstanceViewsHierarchyComponent,
        InstanceWizardAddComponent,
        InstanceWizardDetailsComponent,
        InstanceWorkpackReportsComponent,
        InstanceConfigurationDataComponent,
        InstanceConfigurationSidebarComponent,
        InstanceInformateConfigurationSettingsComponent,
        HierarchyIdmsViewsComponent,
        HierarchyViewEditComponent,
        LineNumberFormatDetailsComponent,
        JoinIdFormatDetailsComponent,
        NestedRenderComponent,
        InstanceConfSidebarDataComponent,
    ],
    imports: [
        MaterialModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AvatarModule,
        HomeModule,
        SettingsModule,
        TranslocoModule,
        InsOrgHeadersModule,
        RouterModule,
        ColorPickerModule,
        NgJsonEditorModule,
        ReportsModule,
        SharedModule,
    ],
    exports: [InstanceActivityPackStatusComponent, InstanceProjectTypeStatusComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AddInstanceModule {}
